
<template>
  <div id="data-list-list-view" class="data-list-container">
    <vx-card>

      <div class="vx-row">
        <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
          <vs-breadcrumb>
            <li><router-link to="/">Dashboard</router-link><span class="vs-breadcrum--separator">/</span></li>
            <li aria-current="page" class="active">Factures</li>
          </vs-breadcrumb>
        </div>
        <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-2 text-right">
          <vs-button type="line" line-origin="left" color="danger" class="mr-5"  @click="filterFildes()">
            <feather-icon icon="FilterIcon" svgClasses="h-4 w-4" v-if="!filter" /> <feather-icon icon="XCircleIcon" svgClasses="h-4 w-4" v-if="filter" /> Filtrer
          </vs-button>
        </div>
      </div>

      <div class="vx-row w-full mb-2" v-if="filter">
        <div class="vx-col md:w-1/6 w-full">
          <vs-input label="N°" v-model="f_num" class="mr-1 w-full" />
        </div>

        <div class="vx-col md:w-1/6 w-full">
          <div class="vs-component vs-con-input-label vs-input  w-full vs-input-primary">
            <label for="" class="vs-input--label">Clients</label>
            <v-select multiple class="w-full" name="client_ids" :clearable="true" label="full_name" v-model="f_clients_id" :options="Client_choices" :reduce="client => client.id" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                <div slot="no-options">Désolé, aucun client correspondante.</div>
            </v-select>
          </div>
        </div>

        <div class="vx-col md:w-1/6 w-full">
          <div class="vs-component vs-con-input-label vs-input  w-full vs-input-primary">
            <label for="" class="vs-input--label">Filtrer par artisans</label>
            <v-select multiple class="w-full" name="artisan_ids" :clearable="true" label="full_name" v-model="f_artisans_id" :options="Artisan_choices" :reduce="artisan => artisan.id" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                <div slot="no-options">Désolé, aucun artisan correspondante.</div>
            </v-select>
          </div>
        </div>

        <div class="vx-col md:w-1/6 w-full">
          <div class="vs-component vs-con-input-label vs-input  w-full vs-input-primary">
            <label for="" class="vs-input--label" >Etat</label>
            <v-select name="etat" class="ml-1" :clearable="false" label="label" v-model="f_etat" :options="status_choices" :reduce="status => status.value" :dir="$vs.rtl ? 'rtl' : 'ltr'">
              <div slot="no-options">Désolé, aucune etat correspondante.</div>
            </v-select>
          </div>
        </div>

        <div class="vx-col md:w-1/3 w-full">
          <div class="flex flex-col vs-component vs-con-input-label vs-input w-full vs-input-primary ">
            <label for="" class="vs-input--label" >Date de création</label>
            <date-range-picker
              style="max-width: 350px;"
              class="mt-2"
              ref="picker"
              :locale-data="{ direction: 'ltr',
                              format: 'mm/dd/yyyy',
                              separator: ' - ',
                              applyLabel: 'Valider',
                              cancelLabel: 'Annuler',
                              weekLabel: 'W',
                              customRangeLabel: 'Custom Range',
                              daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
                              monthNames: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                              firstDay: 0
                            }"
              v-model="dateRange"
              :ranges="{
                'Today': [today, new Date(today.getFullYear(), today.getMonth(), today.getDate(), 11, 59, 59, 999)],
                'Yesterday': [new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1), new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1, 11, 59, 59, 999)],
                'This month': [new Date(today.getFullYear(), today.getMonth(), 1), new Date(today.getFullYear(), today.getMonth() + 1, 0, 11, 59, 59, 999)],
                'Last month': [new Date(today.getFullYear(), today.getMonth() - 1, 1),new Date(today.getFullYear(), today.getMonth(), 0, 11, 59, 59, 999)],
                'This year': [new Date(today.getFullYear(), 0, 1),new Date(today.getFullYear(), 11, 31, 11, 59, 59, 999)],
                'Last year': [new Date(today.getFullYear() - 1, 0, 1),new Date(today.getFullYear() - 1, 11, 31, 11, 59, 59, 999)]
              }"
            >
                <template v-slot:input="picker" style="min-width: 350px;">
                <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4" />
                    {{ picker.startDate | moment("DD-MMMM-YYYY") }} - {{ picker.endDate | moment("DD-MMMM-YYYY") }}
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />

                </template>

                <!--    ranges (new slot syntax) -->
                <template #ranges="ranges">
                  <div class="ranges">
                    <ul>
                      <li v-for="(range, name) in ranges.ranges" :key="name" @click="ranges.clickRange(range)">
                        <b v-if="name == 'Today'">Aujourd'hui</b>
                        <b v-if="name == 'Yesterday'"> Hier</b>
                        <b v-if="name == 'This month'"> Ce mois</b>
                        <b v-if="name == 'This year'"> Cette année</b>
                        <b v-if="name == 'Last month'">Mois dérnier</b>
                        <b v-if="name == 'Last year'">Année dérnière</b>
                      </li>
                    </ul>
                  </div>
                </template>
            </date-range-picker>
          </div>
        </div>
      </div>

      <vs-table ref="table"  v-model="selected" pagination :max-items="itemsPerPage" :data="filteredItems" noDataText="Aucune facture trouvé">


        <template slot="thead">
          <vs-th sort-key="num_invoice">N°</vs-th>
          <vs-th sort-key="intervention.id">N° intervention</vs-th>
          <vs-th >Client</vs-th>
          <vs-th sort-key="ht">Total HT</vs-th>
          <vs-th sort-key="ttc">Total TTC</vs-th>
          <vs-th >Artisans</vs-th>
          <vs-th sort-key="date">Date de création</vs-th>
          <vs-th>Avis client</vs-th>
          <vs-th sort-key="status">Status</vs-th>
          <vs-th>A-F</vs-th>
        </template>

          <template slot-scope="{data}">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                <vs-td>
                  <p @click="editData(tr.intervention.id)" class="num_object">{{ tr.num_invoice }}</p>
                </vs-td>

                <vs-td>
                  <p>BI{{ tr.intervention.id | strPadStart('0') }}</p>
                </vs-td>

                <vs-td>
                  <p>{{ tr.client.company ? tr.client.company : (tr.client.firstname +' '+ tr.client.lastname) }}</p>
                </vs-td>

                <vs-td>
                  <p>{{ tr.ht }} €</p>
                </vs-td>

                <vs-td>
                  <p>{{ tr.ttc }} €</p>
                </vs-td>

                 <vs-td>
                  <p>{{ tr.intervention.artisans.map(artisan => artisan.firstname + ' ' +artisan.lastname).join(",") }}</p>
                </vs-td>


                <vs-td>
                  <p>{{ tr.date | date }}</p>
                </vs-td>

                <vs-td>
                  <p> 
                    <vs-chip v-if="tr.intervention.send_avis" color="success">envoyé</vs-chip>
                    <vs-chip v-else color="danger">pas envoyé</vs-chip>
                  </p>
                </vs-td>

                <vs-td>
                  <p>
                    <vs-dropdown vs-trigger-click>
                      <vs-chip v-if="tr.status == 'issued'" color="#ff9f43">Créé <i class="material-icons">arrow_drop_down</i></vs-chip>
                      <vs-chip v-if="tr.status == 'sent'" color="#005cf6">Envoyé <i class="material-icons">arrow_drop_down</i></vs-chip>
                      <vs-chip v-if="tr.status == 'paid'" color="#28c76f">Payé <i class="material-icons">arrow_drop_down</i></vs-chip>
                      <vs-chip v-if="tr.status == 'partial'" color="#15daf0">Payé en partie <i class="material-icons">arrow_drop_down</i></vs-chip>

                      <vs-dropdown-menu >
                        <vs-dropdown-item @click="changeStatus(tr.id,tr.status,'issued')"> Créé </vs-dropdown-item>
                        <vs-dropdown-item @click="changeStatus(tr.id,tr.status,'sent')"> Envoyé </vs-dropdown-item>
                        <vs-dropdown-item @click="changeStatus(tr.id,tr.status,'paid')"> Payé </vs-dropdown-item>
                        <vs-dropdown-item @click="changeStatus(tr.id,tr.status,'partial')"> Payé en partie </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </p>
                </vs-td>

                <vs-td>
                  <span v-if="tr.num_invoice >= 1073">
                    <vs-button color="primary" type="filled" size="small" v-if="!autoFactureId(tr)" @click="showPrompt(tr)">Générer A-F</vs-button>
                    <router-link :to="{ name: 'auto-facture', params: {id: autoFactureId(tr).id }}" v-if="autoFactureId(tr)">{{ autoFactureId(tr).num }}</router-link>
                  </span>
                </vs-td>

              </vs-tr>
            </tbody>
          </template>
      </vs-table>

      <table>
        <tr>
          <td class="font-semibold">Total HT :</td>
          <td class="pl-5">{{ totaleHt }} €</td>
        </tr>
        <tr>
          <td class="font-semibold">Total TTC :</td>
          <td class="pl-5">{{ totaleTtc }} €</td>
        </tr>
        <tr>
          <td class="font-semibold">Nbrs factures</td>
          <td class="pl-5">{{ nbrs }}</td>
        </tr>
      </table>
    </vx-card>

    <vs-prompt
      title= "Générer Auto-Facture"
      @accept="acceptAlert"
      accept-text= "Générer"
      cancel-text = "Annuler"
      :is-valid="validPrompt"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <table class="w-full">
          <tr>
            <td class="font-semibold w-1/3">N° intervention</td>
            <td class="pl-5">{{ selectInvoice.numIntervention }}</td>
          </tr>
          <tr>
            <td class="font-semibold w-1/3">Client</td>
            <td class="pl-5">{{ selectInvoice.client }}</td>
          </tr>
          <tr>
            <td class="font-semibold w-1/3">Artisan</td>
            <td class="pl-5">
              <v-select class="w-full mr-1" :clearable="false" label="full_name" v-model="selectInvoice.artisan_id" :options="Artisan_choices" :reduce="artisan => artisan.id" :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </td>
          </tr>

        </table>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { moment } from 'vue-moment';
import { mapGetters, mapActions } from "vuex"

export default {
  components: {
    vSelect,DateRangePicker,moment
  },
  data() {
    let today = new Date()
    today.setHours(0, 0, 0, 0)

    return {
      selected: [],
      itemsPerPage: 10,
      isMounted: false,
      sidebarData: {},
      showLoading: false,

      status_choices : [
        {value: null, label: 'Tous'},
        {value: 'issued', label: 'Créé'},
        {value: 'sent', label: 'Envoyé'},
        {value: 'paid', label: 'Payé'},
        {value: 'partial', label: 'Payé en partie'},
      ],

      configFromdateTimePicker: {
        maxDate: null
      },
      configTodateTimePicker: {
        minDate: null
      },

      filter : false,
      f_num: "",
      f_artisans_id: [],
      f_clients_id: [],
      f_etat: null,

      dateRange: {
        startDate: this.$moment().startOf('month').format('YYYY-MM-DD'),
        endDate: this.$moment().format('YYYY-MM-DD')
      },

      activePrompt:false,
      selectInvoice: {
        idIntervention: null,
        numIntervention: null,
        client: null,
        artisan_id: null
      },
      today: today
      

    }
  },
  computed: {
    ...mapGetters('invoices', { 'data' : 'GET_ITEMS' }),
    ...mapGetters('artisans', {'Artisan_choices' : 'GET_ITEMS_FULL_NAME'}),
    ...mapGetters('clients', {'Client_choices' : 'GET_ITEMS_FULL_NAME'}),
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.data.length
    },
    filteredItems() {
      let dataFilter = this.data

      if(this.f_num != null && this.f_num != "") {
        dataFilter = dataFilter.filter(item => {
          return item.num_invoice.toLowerCase().includes(this.f_num.toLowerCase())
        })
      }

      if(this.f_artisans_id != null && this.f_artisans_id.length > 0) {
        dataFilter = dataFilter.filter(item => {
          return item.intervention.artisans.findIndex(artisan => (this.f_artisans_id.includes(artisan.id))) > -1
        })
      }

      if(this.f_clients_id != null && this.f_clients_id.length > 0) {
        dataFilter = dataFilter.filter(item => {
          return this.f_clients_id.includes(item.client_id)
        })
      }

      if(this.f_etat != null) {
        dataFilter = dataFilter.filter(item => {
          return this.f_etat == item.status
        })
      }

      if(this.f_fromDate != null && this.f_toDate != null){
          dataFilter = dataFilter.filter(item => {
            return this.format_date(item.date) >= this.format_date(this.dateRange.startDate) && this.format_date(item.date) <= this.format_date(this.dateRange.endDate)
          })
      }

      var search_object = {
        'num' : this.f_num,
        'artisans_id' : this.f_artisans_id,
        'clients_id' : this.f_clients_id,
        'etat' : this.f_etat,
        'fromDate' : this.dateRange.startDate,
        'toDate' : this.dateRange.endDate
      }

      localStorage.setItem("factures_search", JSON.stringify(search_object))

      return dataFilter
    },
    totaleHt() {
      let num =  this.filteredItems.filter(item => !['1091','1036','1042','1043'].includes(item.num_invoice)).reduce((sum, i) =>sum + i.ht, 0)
      return Math.round((num + Number.EPSILON) * 100) / 100
    },
    totaleTtc() {
      let num = this.filteredItems.filter(item => ['1091','1036','1042','1043'].includes(item.num_invoice) == false).reduce((sum, i) =>sum + i.ttc, 0)
      return Math.round((num + Number.EPSILON) * 100) / 100
    },
    nbrs() {
      return this.filteredItems.length
    },

    autoFactureId() {
      return tr => {
        var artisan_id =  tr.intervention.artisans.length ? tr.intervention.artisans[0].id : null
        var invoice = tr.intervention.auto_invoices.length ? tr.intervention.auto_invoices.find(invoice =>  invoice.artisan_id == artisan_id ) : null
        return invoice ? {id: invoice.id ,num: invoice.num_auto_invoice} : null
      }
    }
  },
  watch: {
    showLoading (val) {
      if(val == true){
        this.$vs.loading({type: 'radius', color: '#be092f'})
      }else{
        this.$vs.loading.close()
      }
    }
  },
  methods: {
    ...mapActions('invoices', ['fetchItems','updateStatus']),
    ...mapActions('artisans', {'fetchArtisans':'fetchItemsFullName'}),
    ...mapActions('clients', {'fetchClients':'fetchItemsFullName'}),

    editData(id) {
      this.$router.push(`/intervention/${id}`);
    },

    successMsg(title,msg){
      this.$vs.notify({
        title: title,
        text: msg,
        color:'success',
        iconPack: 'feather',
        icon:'icon-check',
        position:'top-right'
      })
    },
    errorMsg(title,msg){
      this.$vs.notify({
        title: title,
        text: msg,
        color:'danger',
        iconPack: 'feather',
        icon:'icon-check',
        position:'top-right'
      })
    },
    filterFildes() {
      this.filter = !this.filter
      if(!this.filter) {
        this.f_num = ""
        this.f_artisans_id = []
        this.f_clients_id = []
        this.f_etat = null

        this.dateRange = {
          startDate: this.$moment().startOf('month').format('YYYY-MM-DD'),
          endDate: this.$moment().format('YYYY-MM-DD')
        },

        localStorage.removeItem("factures_search");
      }
    },
    changeStatus(id, old_status, new_status) {
      if(old_status != new_status){
        this.updateStatus({id: id, status: new_status})
      }
    },
    onFromChange(selectedDates, dateStr, instance) {
      this.$set(this.configTodateTimePicker, 'minDate', dateStr);
    },
    onToChange(selectedDates, dateStr, instance) {
      this.$set(this.configFromdateTimePicker, 'maxDate', dateStr);
    },
    genererAF(tr) {
      this.$router.push({ name: 'auto-facture', params: {intervention_id: tr.intervention_id,artisan_id: tr.intervention.artisans.length ? tr.intervention.artisans[0].id : null }})
    },
    acceptAlert(){
      this.showLoading = true
      setTimeout(() => {
        this.showLoading = false
        setTimeout(() => {
          this.$router.push({ name: 'auto-facture', params: {intervention_id: this.selectInvoice.idIntervention,artisan_id: this.selectInvoice.artisan_id }})
        }, 100);
      }, 1000);
    },
    showPrompt(tr) {
      this.selectInvoice.idIntervention = tr.intervention_id
      this.selectInvoice.numIntervention = 'BI'+tr.intervention_id.toString().padStart(4,'0')
      this.selectInvoice.client = tr.client.company ? tr.client.company : tr.client.firstname+' '+tr.client.lastname
      this.selectInvoice.artisan_id = tr.intervention.artisans.length ? tr.intervention.artisans[0].id : null
      this.activePrompt = true
    },
    format_date(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
          month = '0' + month;
      if (day.length < 2)
          day = '0' + day;

      return [year, month, day].join('-');
    },
  },
  created() {
    this.fetchItems()
    this.fetchArtisans()
    this.fetchClients()

    var search_object = JSON.parse(localStorage.getItem("factures_search") || "[]")
    if(search_object && (search_object.num || search_object.artisans_id.length || search_object.clients_id.length || search_object.etat || search_object.fromDate || search_object.toDate)) {
      this.f_num = search_object.num
      this.f_artisans_id = search_object.artisans_id
      this.f_clients_id = search_object.clients_id
      this.f_etat = search_object.etat
      this.f_fromDate = search_object.fromDate
      this.f_toDate = search_object.toDate

      this.dateRange.startDate = search_object.fromDate
      this.dateRange.endDate = search_object.toDate

      this.filter = true
    }
  },
  mounted() {
    this.isMounted = true;
  },
  filters:{
    strPadStart(value, pattern = "") {
      return value.toString().padStart(4,pattern)
    },
    date(value) {
      var [y, m, d] = value.split("-")
      return d+'/'+m+'/'+y
    }
  }
}
</script>

<style scoped>
  .num_object:hover{
    color: #be092f;
  }

  .vuesax-app-is-ltr .con-vs-chip {
    width: 100%;
  }
  .vs-con-dropdown.parent-dropdown {
    width: 100%;
    cursor: pointer !important;
  }
</style>
